import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  showAuth: false,
  type: "login",
};

// Defining Show Login Modal Slice
const showAuthSlice = createSlice({
  name: "showAuth",
  initialState,
  reducers: {
    setShowAuth: (state, { payload }) => {
      state.showAuth = payload?.showAuth ?? state.showAuth;
      state.type = payload?.type ?? state.type;
    },
  },
});

export const { setShowAuth } = showAuthSlice.actions;

export default showAuthSlice.reducer;
